import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [statusMessage, setStatusMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Basic validation
    if (!formData.fullName || !formData.email || !formData.message) {
      setStatusMessage('Please fill in all required fields.');
      setIsError(true);
      return;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
        setStatusMessage('Please enter a valid email address.');
        setIsError(true);
        return;
    }
    if (formData.phone && !/^\d+$/.test(formData.phone)) {
        setStatusMessage('Please enter a valid phone number (digits only).');
        setIsError(true);
        return;
    }

    // Placeholder for form submission logic (e.g., send to an email service or backend)
    console.log('Form data submitted:', formData);
    setStatusMessage('Message Sent Successfully');
    setIsError(false);
    setFormData({
        fullName: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
  };

  const address = '7L44 Vrindawan Society, Kudi, Kudi Bhagtasni Housing Board, Jodhpur, Rajasthan 342005';
  const [mapLoaded, setMapLoaded] = useState(false);
  
  useEffect(() => {
    // Preload the map in the background
    const timer = setTimeout(() => {
      setMapLoaded(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container mt-5 mb-5">
      <div className="row">
        <div className="col-md-6 mb-4 mb-md-0">
          <h2>To Join Us</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="fullName" className="form-label">Full Name <span className="text-danger">*</span></label>
              <input type="text" className="form-control" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email Address <span className="text-danger">*</span></label>
              <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">Phone Number</label>
              <input type="tel" className="form-control" id="phone" name="phone" value={formData.phone} onChange={handleChange} pattern="[0-9]*" />
            </div>
            <div className="mb-3">
              <label htmlFor="subject" className="form-label">Subject</label>
              <input type="text" className="form-control" id="subject" name="subject" value={formData.subject} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">Message <span className="text-danger">*</span></label>
              <textarea className="form-control" id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required></textarea>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
            {statusMessage && (
              <div className={`mt-3 alert ${isError ? 'alert-danger' : 'alert-success'}`} role="alert">
                {statusMessage}
              </div>
            )}
          </form>
        </div>
        <div className="col-md-6">
          <h2>Our Location</h2>
          <div className="position-relative" style={{ borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
              <strong>Our Address:</strong> {address}
            </div>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
              {mapLoaded && (
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3579.5188948879822!2d73.02783821092495!3d26.21232428974291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39418b430324aee1%3A0x314f844be7d1cf3e!2sGeneral%20Pest%20Control%20Services%20Jodhpur!5e0!3m2!1sen!2sin!4v1749223998666!5m2!1sen!2sin" 
                  width="100%" 
                  height="100%" 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 0
                  }} 
                  allowFullScreen 
                  loading="eager" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Our Location on Google Maps"
                  aria-label="Location of General Pest Control Services Jodhpur on Google Maps">
                </iframe>
              )}
              {!mapLoaded && (
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#f8f9fa',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#666',
                  fontSize: '1rem'
                }}>
                  Loading map...
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .map-responsive {
          overflow: hidden;
          padding-bottom: 75%; /* 4:3 aspect ratio for better map visibility */
          position: relative;
          height: 0;
          border-radius: 10px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          margin-top: 1rem;
        }
        .map-responsive iframe {
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          position: absolute;
          border: none;
        }
        
        @media (max-width: 768px) {
          .map-responsive {
            padding-bottom: 75%; /* Maintain aspect ratio on mobile */
            margin-top: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ContactPage;
